import { createSelector, OutputSelector } from "reselect"
// @ts-expect-error: Flow to TS migration.
import type { RouterProps } from "react-router-config"

import { parseQuery } from "./queries"

// @ts-expect-error: Flow to TS migration.
export const queryFromReactRouterPropsSelector: OutputSelector<
  RouterProps,
  undefined,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  {
    [key: string]: string
  }
> = createSelector(
  (props) => props.location.search,
  (search) => parseQuery(search),
)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const urlQuerySelector = (state: any) => state.query
